import { render } from "./ModalFooter.vue?vue&type=template&id=9511a232"
import script from "./ModalFooter.vue?vue&type=script&lang=js"
export * from "./ModalFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ernes\\.ssh\\bipay-laravel-reportes\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ModalFooter.vue"]])

export default __exports__